import { useSelector } from "react-redux";

import { Flyout } from "@/components/General/Flyout/flyout";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as ProfileSidebarModule from "@/redux/modules/value/profileSidebar/profileSidebar.module";
import { getProfileSidebar } from "@/redux/modules/value/profileSidebar/profileSidebar.selectors";
import { TProfileSidebarState } from "@/redux/modules/value/profileSidebar/profileSidebar.types";
import { RenderAndHydrateHtml } from "@/utils/renderers/renderAndHydrateHtml";

type Props = {
    innerHTML: string;
};

export const ProfileSidebarContainer = ({ innerHTML }: Props) => {
    const dispatch = useThunkDispatch();
    const profileSidebar = useSelector(getProfileSidebar);

    const update = (data: TProfileSidebarState) => {
        return dispatch(ProfileSidebarModule.update(data));
    };

    const handleOnClose = () => update({ active: false });

    return (
        <Flyout
            open={!!profileSidebar?.active}
            onClose={handleOnClose}
        >
            <Flyout.Content>
                <RenderAndHydrateHtml innerHtml={innerHTML} />
            </Flyout.Content>
            <Flyout.Controls>
                <Flyout.Controls.CloseButton />
            </Flyout.Controls>
        </Flyout>
    );
};
